import { render, staticRenderFns } from "./detailsPrelevementParent.vue?vue&type=template&id=28436eb0&"
import script from "./detailsPrelevementParent.vue?vue&type=script&lang=js&"
export * from "./detailsPrelevementParent.vue?vue&type=script&lang=js&"
import style0 from "./detailsPrelevementParent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports